<template>
  <div id="content" class="row col s12">
    <template v-if="loading === false">
      <div class="center offline">
        <i class="material-icons">signal_wifi_off</i>
      </div>
      <p class="center">Você está offline. Verifique a sua conexão com a internet e <a @click="retryConnection">tente novamente</a>.</p>
    </template>
    <div v-else class="center offline">
      <loading />
    </div>
  </div>
</template>
<script>
import Loading from '@/components/Loading.vue'

export default {
  name: 'Offline',
  components: {
    'loading': Loading
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    retryConnection(){
      if(navigator.onLine === true){
        document.location.href = '/'
      } else {
        this.loading = true
        setTimeout(() => this.loading = false, 1000)
      }
    }
  },
  mounted() {
  }
}
</script>
<style>
  .offline {
    padding-top: 50%;
  }
  .offline i {
    font-size: 10rem;
    color: #00A0B2;
  }
</style>


// WEBPACK FOOTER //
// src/components/Offline.vue